import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import TravelPage from "./pages/TravelPage";
import RetreatsPage from "./pages/RetreatsPage";
import PracticePage from "./pages/PracticePage";
import ConciergePage from "./pages/ConciergePage";
import InboxPage from "./pages/InboxPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import HelpPage from "./pages/HelpPage";
import NotFoundPage from "./pages/NotFoundPage";
import FitnessPage from "./pages/FitnessPage";
import YogaPage from "./pages/YogaPage";
import VibePage from "./pages/VibePage";
import WellPage from "./pages/WellPage";
import PlaylistsPage from "./pages/PlaylistsPage";
import SupportPage from "./pages/SupportPage";
import JoinPage from "./components/JoinPage";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/join" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/join" element={<JoinPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/travel" element={<TravelPage />} />
        <Route path="/retreats" element={<RetreatsPage />} />
        <Route path="/practice" element={<PracticePage />} />
        <Route path="/fitness" element={<FitnessPage />} />
        <Route path="/yoga" element={<YogaPage />} />
        <Route path="/well" element={<WellPage />} />
        <Route path="/vibe" element={<VibePage />} />
        <Route path="/playlists" element={<PlaylistsPage />} />
        <Route path="/concierge" element={<ConciergePage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
